import { DentalSupplierAddresses } from './../../../checkout/models/dental-supplier-addresses';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { AddAddressComponent } from './../../components/add-address/add-address.component';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GetDentalSupplierAddressesService } from '../../services/get-dental-supplier-addresses.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { switchMap } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { DeleteAddressComponent } from '../../components/delete-address/delete-address.component';
@Component({
  selector: 'app-my-address',
  templateUrl: './my-address.component.html',
  styleUrls: ['./my-address.component.scss']
})
export class MyAddressComponent implements OnInit, AfterViewInit, OnDestroy {
  /* --------------------------------- Fields --------------------------------- */
  filterForm = this.fb.group({
    search: ['', [Validators.required]],
    limit: [10, [Validators.required]],
    offset: [0, [Validators.required]]
  });
  totalElements = 0;
  filterSubject: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterForm.value);
  addressesList: DentalSupplierAddresses[];
  subscription: Subscription;
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private fb: FormBuilder,
    private matDialog: MatDialog,
    private getDentalSupplierAddressesService: GetDentalSupplierAddressesService
  ) { }
  /* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
    this.subscription = this.filterSubject.pipe(switchMap(filter => {
      this.addressesList = null;
      return this.getDentalSupplierAddressesService.getDentalSupplierAddresses(filter);
    })).subscribe(([dental_supplier_addresses, count]: [DentalSupplierAddresses[], number]) => {
      this.addressesList = dental_supplier_addresses;
      console.log(this.addressesList);
      this.totalElements = count;
    });
  }
  ngAfterViewInit(): void {
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  /* ---------------------------- Custom Functions ---------------------------- */
  addAddress() {
    const dialogRef = this.matDialog.open(AddAddressComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      width: '40%'
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  editAddressDialog(dental_supplier_addresses: DentalSupplierAddresses) {
    const dialogRef = this.matDialog.open(AddAddressComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      width: '40%',
      data: dental_supplier_addresses
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  deleteDialog(dental_supplier_addresses: any) {
    const dialogRef = this.matDialog.open(DeleteAddressComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      width: '30%',
      data: dental_supplier_addresses
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  /* --------------------------------- Getters -------------------------------- */
  get search(): AbstractControl {
    return this.filterForm.get("search");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  changePage(e: PageEvent) {
    this.offset.setValue(e.pageSize * e.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
}
